<template>
  <modal class="comment" name="add-category-modal" width="90%" height="auto">
    <Button
      class="close"
      @click.native="$modal.hide('add-category-modal')"
      margin="10px"
      color="#31b9be"
      bgcolor="transparent"
      width="30px"
      padding="0"
      icon="close-blue"
    ></Button>
    <h3>{{ title }}</h3>
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>
    <InputField
      v-model="categoryTitle"
      required
      :placeholder="$t('dash.dictionary.category.form-title')"
    ></InputField>
    <LoadingButton v-if="loading"></LoadingButton>
    <Button
      v-else
      :title="$t('dash.dictionary.action-add')"
      shadow="true"
      @click.native="addCategory"
      margin="1rem 0"
    ></Button>
  </modal>
</template>

<script>
import { neoparentCategories } from "@/api";

export default {
  name: "CategoryModal",
  props: {
    title: { required: true }
  },
  data: function() {
    return {
      error: "",
      categoryTitle: "",
      loading: false
    };
  },
  methods: {
    addCategory() {
      neoparentCategories
        .addCategory({ title: this.categoryTitle })
        .then(result => {
          this.consoleLog(result);
          this.categoryTitle = "";
          this.$emit("add-category");
          this.$modal.hide("add-category-modal");
        })
        .catch(err => {
          this.consoleLog(err);
          this.error = this.$t("error.dictionary.category.missing-title");
        });
    }
  }
};
</script>
